import { useMediaTempCreate } from "@/api/media";
import { useCableDistributionValidate } from "@/api/rfs";
import { CableDistributionFormSchema } from "../CableDistributionField";
import { swalError, swalLoading, swalSuccess } from "@/utils/lib/swal";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { AxiosError } from "axios";

export default function useValidateCableDistribution({ id }: { id?: string }) {
  const { mutate: mutateMedia } = useMediaTempCreate();
  const { mutate: mutateCableDistributionValidate } =
    useCableDistributionValidate();

  function handleSubmit(values: CableDistributionFormSchema) {
    if (
      values.fileCableDistribution &&
      values.fileCableDistribution.length > 0
    ) {
      swalLoading.fire();
      mutateMedia(
        {
          data: {
            file: values?.fileCableDistribution?.[0],
            target: "/abd-document",
          },
        },
        {
          onSuccess: (result) => {
            if (!id) {
              throw new Error(MISSING_ID_IN_ROUTE);
            }
            mutateCableDistributionValidate(
              {
                id,
                data: {
                  hptar: {
                    media: {
                      id: result.id,
                      path: result.path,
                      originalFileName: result.originalFileName,
                      name: result.name,
                    },
                  },
                },
              },
              {
                onSuccess: onSuccess,
                onError: onError,
              },
            );
          },
        },
      );
    }
  }

  function onSuccess() {
    swalSuccess.fire({
      title: "Submission Successful",
      text: "Cable Distribution, Slingwire, and Qspan file has been successfully updated",
    });
  }

  function onError(error: Error) {
    const errorMessage = (error as AxiosError<{ data?: string }>).response?.data
      ?.data;

    swalError.fire({
      title: "Validation Failed",
      text: errorMessage ?? "Please check the file and try again",
    });
  }

  return { handleSubmit };
}
